import { useEffect, useRef, type ReactNode } from "react";
import styles from "./seo-page.module.css";

export function SeoScrollPage({
  children,
  routeKey,
}: {
  children: ReactNode;
  routeKey: string;
}) {
  const pageRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const page = pageRef.current;
    if (!page) return;

    page.scrollTop = 0;
    page.focus({ preventScroll: true });
  }, [routeKey]);

  return (
    <main ref={pageRef} className={styles.page} tabIndex={-1}>
      {children}
    </main>
  );
}
